module.exports = __webpack_public_path__ + "static/media/blured-ubeya-scheduling.723e634f.jpg";